import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const CityWalk = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const images = ["/images/Citywalk1.jpeg", "/images/Citywalk2.jpeg"];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const itinerary = [
    { title: "Pick-Up Point (Wabera Street)", desc: "Meeting point is at Wabera Street just outside Carrefour St. Ellis before the tour begins.", meta: "10 min · Free Entry" },
    { title: "War Monument", desc: "A memorial monument in honor of African soldiers who fought in World Wars I and II.", meta: "10 min · Free Entry" },
    { title: "Jamia Mosque", desc: "This is the biggest mosque in Kenya.", meta: "10 min · Free Entry" },
    { title: "McMillan Memorial Library", desc: "A very old library in the city centre built in 1929 to remember William Macmillan by his wife.", meta: "10 min · Free Entry" },
    { title: "City Market", desc: "A market where they sell traditional items made from different communities especially the Maasai tribe in Kenya — a great place to buy souvenirs.", meta: "20 min · Free Entry" },
    { title: "University of Nairobi", desc: "The oldest and the biggest university in eastern Africa.", meta: "20 min · Free Entry" },
    { title: "The Maasai Market", desc: "A market selling traditional Maasai items and also items from other tribes in Kenya. The best place for souvenirs.", meta: "20 min · Free Entry" },
    { title: "Uhuru Park", desc: "A beautiful park located in the middle of Nairobi city.", meta: "15 min · Free Entry" },
    { title: "Cathedral Basilica of the Holy Family", desc: "A Catholic church located in the city centre.", meta: "10 min · Free Entry" },
    { title: "Kenyatta International Conference Center (KICC)", desc: "From the rooftop of this iconic building we get a clear panoramic view of the city.", meta: "15 min · Ticket Not Included" },
    { title: "Parliament of Kenya", desc: "This is the tower where members of parliament of Kenya hold their meetings.", meta: "10 min · Free Entry" },
    { title: "Nairobi Railway Museum", desc: "This railway was built by the British with the help of Indians in 1895, which led to the creation of the city of Nairobi.", meta: "10 min · Free Entry" },
    { title: "National Archives Moi Avenue", desc: "A collection of different artifacts and documentation of the Kenyan government history since independence.", meta: "10 min · Free Entry" },
    { title: "Jeevanjee Gardens", desc: "A small but vibrant park in the heart of Nairobi city.", meta: "10 min · Free Entry" },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Jost:wght@300;400;500;600&display=swap');

        :root {
          --gold: #C9A84C;
          --gold-light: #E8C97A;
          --dark: #0A0A0A;
          --charcoal: #141414;
        }

        .tw-root {
          font-family: 'Jost', sans-serif;
          background: var(--dark);
          color: #fff;
          min-height: 100vh;
        }

        /* ── HERO ── */
        .tw-hero {
          position: relative;
          min-height: 88vh;
          display: flex;
          align-items: flex-end;
          overflow: hidden;
        }
        .tw-hero-bg {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center;
          transition: opacity 1.8s ease-in-out;
        }
        .tw-hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to top,
            rgba(10,10,10,1) 0%,
            rgba(10,10,10,0.55) 45%,
            rgba(10,10,10,0.3) 100%
          );
        }
        .tw-hero-content {
          position: relative;
          z-index: 2;
          padding: 4rem 1.5rem 5rem;
          max-width: 860px;
          animation: fadeUp 1.2s ease both;
        }
        @keyframes fadeUp {
          from { opacity:0; transform:translateY(32px); }
          to   { opacity:1; transform:translateY(0); }
        }
        .tw-eyebrow {
          font-size: 0.68rem;
          letter-spacing: 5px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 1rem;
        }
        .tw-hero-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(3rem, 7vw, 5.5rem);
          font-weight: 700;
          line-height: 1.05;
          color: #fff;
          margin-bottom: 0.4rem;
        }
        .tw-hero-title em { font-style: italic; color: var(--gold-light); }
        .tw-hero-divider {
          width: 55px;
          height: 2px;
          background: var(--gold);
          margin: 1.4rem 0;
        }
        .tw-hero-desc {
          font-size: clamp(0.95rem, 2vw, 1.1rem);
          font-weight: 300;
          color: rgba(255,255,255,0.78);
          line-height: 1.9;
          max-width: 600px;
          margin-bottom: 2.2rem;
        }
        .tw-hero-pills {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 2.5rem;
        }
        .tw-pill {
          border: 1px solid rgba(201,168,76,0.45);
          color: var(--gold-light);
          padding: 0.3rem 1rem;
          border-radius: 50px;
          font-size: 0.72rem;
          letter-spacing: 2px;
          text-transform: uppercase;
          font-weight: 500;
        }
        .tw-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: var(--gold);
          color: #0A0A0A;
          border: none;
          padding: 0.9rem 2.6rem;
          font-family: 'Jost', sans-serif;
          font-weight: 600;
          font-size: 0.82rem;
          letter-spacing: 3px;
          text-transform: uppercase;
          border-radius: 3px;
          cursor: pointer;
          transition: background 0.3s, transform 0.2s;
          text-decoration: none;
        }
        .tw-btn:hover { background: var(--gold-light); transform: translateY(-2px); color: #0A0A0A; }

        /* ── STATS STRIP ── */
        .tw-stats {
          background: var(--charcoal);
          border-top: 1px solid rgba(201,168,76,0.2);
          border-bottom: 1px solid rgba(201,168,76,0.2);
          padding: 1.8rem 1rem;
        }
        .tw-stat { text-align: center; padding: 0.4rem 1rem; }
        .tw-stat-n {
          font-family: 'Cormorant Garamond', serif;
          font-size: 2.2rem;
          font-weight: 700;
          color: var(--gold);
          line-height: 1;
        }
        .tw-stat-l {
          font-size: 0.65rem;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.4);
          margin-top: 0.2rem;
        }

        /* ── GALLERY ── */
        .tw-gallery {
          padding: 5rem 0 4rem;
          background: var(--dark);
        }
        .tw-section-label {
          font-size: 0.65rem;
          letter-spacing: 5px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.6rem;
        }
        .tw-section-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(1.8rem, 4vw, 2.8rem);
          font-weight: 700;
          color: #fff;
          margin-bottom: 0.4rem;
        }
        .tw-section-line {
          width: 40px;
          height: 2px;
          background: var(--gold);
          margin-bottom: 2.5rem;
        }
        .tw-img-frame {
          position: relative;
          border-radius: 8px;
          overflow: hidden;
          aspect-ratio: 16/9;
          max-width: 760px;
          margin: 0 auto;
          box-shadow: 0 30px 80px rgba(0,0,0,0.6);
          border: 1px solid rgba(201,168,76,0.15);
        }
        .tw-img-frame img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: opacity 1.4s ease-in-out;
        }
        .tw-img-dots {
          display: flex;
          justify-content: center;
          gap: 0.5rem;
          margin-top: 1.4rem;
        }
        .tw-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255,255,255,0.25);
          border: none;
          cursor: pointer;
          transition: background 0.3s, transform 0.3s;
          padding: 0;
        }
        .tw-dot.active { background: var(--gold); transform: scale(1.4); }

        /* ── ITINERARY ── */
        .tw-itinerary {
          background: var(--charcoal);
          padding: 5rem 0 6rem;
          border-top: 1px solid rgba(201,168,76,0.12);
        }
        .tw-timeline {
          max-width: 720px;
          margin: 0 auto;
          position: relative;
        }
        .tw-tl-item {
          display: flex;
          gap: 1.8rem;
          margin-bottom: 2.4rem;
          animation: fadeUp 0.6s ease both;
        }
        .tw-tl-item:last-child { margin-bottom: 0; }
        .tw-tl-dot {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: rgba(201,168,76,0.08);
          border: 1px solid rgba(201,168,76,0.35);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-family: 'Cormorant Garamond', serif;
          font-size: 0.95rem;
          font-weight: 700;
          color: var(--gold);
          position: relative;
          z-index: 2;
        }
        .tw-tl-body {
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(201,168,76,0.1);
          border-radius: 6px;
          padding: 1.2rem 1.5rem;
          flex: 1;
          transition: border-color 0.3s;
        }
        .tw-tl-body:hover { border-color: rgba(201,168,76,0.4); }
        .tw-tl-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 1.15rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 0.3rem;
        }
        .tw-tl-desc {
          font-size: 0.85rem;
          font-weight: 300;
          color: rgba(255,255,255,0.55);
          line-height: 1.75;
          margin-bottom: 0.5rem;
        }
        .tw-tl-meta {
          font-size: 0.62rem;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: var(--gold);
          opacity: 0.8;
        }

        /* ── CTA ── */
        .tw-cta {
          background: linear-gradient(135deg, #1a1200 0%, #2a1f00 50%, #1a1200 100%);
          border-top: 1px solid rgba(201,168,76,0.2);
          padding: 5rem 1.5rem;
          text-align: center;
        }
        .tw-cta h2 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 700;
          color: #fff;
          margin-bottom: 1rem;
        }
        .tw-cta p {
          font-size: 0.92rem;
          color: rgba(255,255,255,0.55);
          max-width: 480px;
          margin: 0 auto 2.5rem;
          line-height: 1.85;
        }

        @media (max-width: 576px) {
          .tw-hero-content { padding: 3rem 1.2rem 4rem; }
          .tw-tl-dot { width: 36px; height: 36px; font-size: 0.8rem; }
        }
      `}</style>

      <div className="tw-root">

        {/* HERO */}
        <section className="tw-hero">
          {images.map((img, i) => (
            <div
              key={i}
              className="tw-hero-bg"
              style={{ backgroundImage: `url(${img})`, opacity: i === currentImage ? 1 : 0 }}
            />
          ))}
          <div className="tw-hero-overlay" />
          <div className="container">
            <div className="tw-hero-content">
              <p className="tw-eyebrow">Nairobi · Kenya</p>
              <h1 className="tw-hero-title">
                Downtown <em>City</em><br />Walk Tour
              </h1>
              <div className="tw-hero-divider" />
              <p className="tw-hero-desc">
                Anyone can see Nairobi from a car window — but only by walking do you hear the heartbeat of the city.
                Feel the energy, connect with the people, and carry home stories you'll tell for years.
              </p>
              <div className="tw-hero-pills">
                <span className="tw-pill">3–4 Hours</span>
                <span className="tw-pill">$20 Per Person</span>
                <span className="tw-pill">Expert Guides</span>
                <span className="tw-pill">14 Landmarks</span>
              </div>
              <button className="tw-btn" onClick={() => window.location.href = "/tours"}>
                Book This Tour
              </button>
            </div>
          </div>
        </section>

        {/* STATS */}
        <div className="tw-stats">
          <div className="container">
            <div className="row justify-content-center">
              {[
                { n: "14", l: "Landmarks" },
                { n: "3–4", l: "Hours" },
                { n: "$20", l: "Per Person" },
                { n: "5★", l: "Rated" },
              ].map((s, i) => (
                <div key={i} className="col-6 col-md-3">
                  <div className="tw-stat">
                    <div className="tw-stat-n">{s.n}</div>
                    <div className="tw-stat-l">{s.l}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* GALLERY */}
        <section className="tw-gallery">
          <div className="container">
            <p className="tw-section-label">Experience Gallery</p>
            <h2 className="tw-section-title">The Walk</h2>
            <div className="tw-section-line" />
            <div className="tw-img-frame">
              {images.map((img, i) => (
                <img key={i} src={img} alt={`City Walk ${i + 1}`} style={{ opacity: i === currentImage ? 1 : 0 }} />
              ))}
            </div>
            <div className="tw-img-dots">
              {images.map((_, i) => (
                <button key={i} className={`tw-dot ${i === currentImage ? "active" : ""}`} onClick={() => setCurrentImage(i)} />
              ))}
            </div>
          </div>
        </section>

        {/* ITINERARY */}
        <section className="tw-itinerary">
          <div className="container">
            <p className="tw-section-label" style={{ textAlign: "center" }}>Your Journey</p>
            <h2 className="tw-section-title" style={{ textAlign: "center" }}>Full Itinerary</h2>
            <div className="tw-section-line" style={{ margin: "0 auto 3rem" }} />
            <div className="tw-timeline">
              {itinerary.map((item, i) => (
                <div key={i} className="tw-tl-item">
                  <div className="tw-tl-dot">{i + 1}</div>
                  <div className="tw-tl-body">
                    <div className="tw-tl-title">{item.title}</div>
                    <div className="tw-tl-desc">{item.desc}</div>
                    <div className="tw-tl-meta">{item.meta}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="tw-cta">
          <h2>Ready to Walk Nairobi?</h2>
          <p>
            Join hundreds of travellers who've discovered the city's true heartbeat on foot.
            Book your spot today.
          </p>
          <button className="tw-btn" onClick={() => window.location.href = "/tours"}>
            Book Your Experience
          </button>
        </section>

      </div>
    </>
  );
};

export default CityWalk;
